import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-tryangle_down",
  "use": "vab-icon-tryangle_down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-tryangle_down\">\n<path d=\"M12.7072 15.5001C12.3167 15.8906 11.6835 15.8906 11.293 15.5001L5.70721 9.91429C5.07724 9.28432 5.52341 8.20718 6.41431 8.20718L17.5859 8.20718C18.4768 8.20718 18.923 9.28433 18.293 9.91429L12.7072 15.5001Z\" fill=\"#09244B\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol